import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

import { useTranslationDelete } from '../model/TranslationQuery';

interface TranslationDeleteButtonProps {
  translationId: Id;
}

export function TranslationDeleteButton({ translationId }: TranslationDeleteButtonProps) {
  const mutation = useTranslationDelete(translationId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
